import request from '@/plugin/axios'
import request2 from '@/plugin/axios/flsc2'
import requesttp6 from '@/plugin/axios/tp6'

// 额外基础路径
const url = 'index.php?'

export function shareWarehouse (params) {
  return get(params)
}
export function flscGet (params) {
  return get(params)
}
export function shareWarehousePost (params, data) {
  return post(params, data)
}
export function flscPost (params, data) {
  return post(params, data)
}

export function flscDownload (params, data) { // 下载文件
  return download(params, data)
}

export function shareWarehousePost2 (params, data) {
  return post2(params, data)
}

export function upload (params, data) {
  return files(params, data)
}



// starttp6
export function upload1 (params, data) {
  return filestp6(params, data)
}
export function flscGet1 (urltp6, params) {
  return gettp6(urltp6, params)
}
export function flscPost1 (urltp6, data) {
  return posttp6(urltp6, data)
}
export function flscDelete1 (urltp6, data) {
  return deletetp6(urltp6, data)
}
export function flscPut1 (urltp6, data) {
  return puttp6(urltp6, data)
}

export function flscDownload1 (urltp6, params) { // 下载文件
  return downloadtp6(urltp6, params)
}
// endtp6

function get (params) {
  return request({
    params,
    url,
    method: 'get'
  })
}

function post (params, data) {
  return request({
    params,
    url,
    method: 'post',
    data
  })
}

function download (params) { // 下载文件
  return request({
    params,
    url,
    method: 'get',
    responseType: 'blob',
  })
}

// starttp6
function gettp6 (urltp6, params) {
  return requesttp6({
    params,
    url: urltp6,
    method: 'get'
  })
}

function posttp6 (urltp6, data) {
  return requesttp6({
    url: urltp6,
    method: 'post',
    data
  })
}

function filestp6 (urltp6, data) { //tp6上传
  return requesttp6({
    url:urltp6,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  })
}

function deletetp6 (urltp6, data) {
  return requesttp6({
    url: urltp6,
    method: 'delete',
    data
  })
}
function puttp6 (urltp6, data) {
  return requesttp6({
    url: urltp6,
    method: 'put',
    data
  })
}

function downloadtp6 (urltp6, params) { // 下载文件
  return requesttp6({
    params,
    url: urltp6,
    method: 'get',
    responseType: 'blob',
  })
}
// endtp6

// function get2 (params) {
//   return request2({
//     params,
//     url,
//     method: 'get'
//   })
// }

function post2 (params, data) {
  return request2({
    params,
    url,
    method: 'post',
    data
  })
}

function files (params, data) {
  return request({
    method: 'post',
    url,
    params,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}
